import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");

  function convertToFarenheit(event) {
    event.preventDefault();
    setUnit("farenhheit");
  }

  function convertToCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <span>
        <span>{props.celsius}</span>
        <span className="unit">
          ℃|
          <a href="/" onClick={convertToFarenheit}>
            ℉
          </a>
        </span>
      </span>
    );
  } else {
    let farenheit = Math.round((props.celsius * 9) / 5 + 32);
    return (
      <span>
        <span>{farenheit}</span>
        <span className="unit">
          <a href="/" onClick={convertToCelsius}>
            ℃{" "}
          </a>
          | ℉
        </span>
      </span>
    );
  }
}
